import { IFieldFilter, ISortFilter } from '@/models/filters/Filters';

export interface IMappedQueryFilters {
  skip: number;
  take: number;
  sort_prop?: string;
  sort_order?: string;
  filter_value?: string | string[];
  filter_by?: string;
  initial_value?: (number | string)[];
}

export class QueryFilters {
  public page: number = 1;
  public rowsPerPage: number = 20;
  public sortFilter?: ISortFilter;
  public fieldFilter?: IFieldFilter;
  public initialValue?: number[] | string[];

  constructor(initData: Partial<QueryFilters>) {
    Object.assign(this, initData);
  }

  public mapQueryFilterToRequestParams(): IMappedQueryFilters {
    const limit = this.rowsPerPage;
    const offset = limit * (this.page - 1);

    const filter: IMappedQueryFilters = {
      skip: offset,
      take: limit,
    };

    if (this.sortFilter) {
      const { sortBy, descending } = this.sortFilter;
      const sortOrder = descending ? 'desc' : 'asc';

      filter.sort_prop = sortBy;
      filter.sort_order = sortOrder;
    }
    if (this.fieldFilter) {
      if (typeof this.fieldFilter.filterValue === 'string')
        filter.filter_value = this.fieldFilter.filterValue;
      filter.filter_by = this.fieldFilter.filterBy;
    }
    if (this.initialValue) {
      filter.initial_value = this.initialValue;
    }

    return filter;
  }
}
